import * as React from 'react';

function SvgSliders(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 23.89 21.89" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M3.48 1.99v2H0v-2zm10 8v2H0V9.93zm-8 8v2H0v-2.06zM8.93 0a1 1 0 011 1v3.93a1 1 0 01-.29.7 1 1 0 01-.71.3h-4a1 1 0 01-1-1v-4a1 1 0 011-1zm2 15.93a1 1 0 01.7.29.94.94 0 01.3.71v4a.94.94 0 01-.29.7 1 1 0 01-.7.3H6.93a.94.94 0 01-.7-.3 1 1 0 01-.3-.7v-4a1 1 0 01.3-.7 1 1 0 01.7-.3zm13-13.94v2H10.45v-2zm0 15.94v2H12.44v-2zm-5-10a1 1 0 01.7.29 1 1 0 01.3.71v4a1 1 0 01-1 1h-4a1 1 0 01-.7-.3.93.93 0 01-.3-.7v-4a.94.94 0 01.29-.7 1 1 0 01.71-.3zm5 2v2h-3.52v-2z" />
    </svg>
  );
}

const MemoSvgSliders = React.memo(SvgSliders);
export default MemoSvgSliders;
